/**
 * Debug utility that only logs in development environment
 * In production builds, these calls are stripped or no-op
 */

const isDevEnvironment = (() => {
  try {
    return Boolean((import.meta as any).env?.DEV)
  } catch {
    return false
  }
})()

export const debugLog = (...args: unknown[]) => {
  if (isDevEnvironment) {
    console.log(...args)
  }
}

export const debugWarn = (...args: unknown[]) => {
  if (isDevEnvironment) {
    console.warn(...args)
  }
}

export const debugError = (...args: unknown[]) => {
  // Always log errors, even in production, but you can change this if needed
  console.error(...args)
}

export const debugTable = (data: unknown) => {
  if (isDevEnvironment && console.table) {
    console.table(data)
  }
}

export const debugGroup = (label: string) => {
  if (isDevEnvironment && console.group) {
    console.group(label)
  }
}

export const debugGroupEnd = () => {
  if (isDevEnvironment && console.groupEnd) {
    console.groupEnd()
  }
}

// Export a single debug object for convenience
export const debug = {
  log: debugLog,
  warn: debugWarn,
  error: debugError,
  table: debugTable,
  group: debugGroup,
  groupEnd: debugGroupEnd,
  isDevEnvironment,
}
